import Img1 from "../images/download/appstore.svg";
import Img2 from "../images/download/googleapp.svg";

function Download() {
  return (
    <>
      <section className="download-section">
        <div className="container">
          <div className="download-text" style={{fontFamily:'Montserrat'}}>
            <h2>Download our app to get most out of it</h2>
            <p style={{fontFamily:'Montserrat'}}>
              Thrown shy denote ten ladies though ask saw. Or by to he going
              think order event music. Incommode so intention defective at
              convinced. Led income months itself and houses you.
            </p>
            <div className="download-text__btns">
              <img alt="download_img" src={Img2} className="download-img" />
              <img alt="download_img" src={Img1} className="download-img" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Download;
